import svg from "./material-icon.svg?react";
import { makeSvgIcon } from "./svg-icon";

export const MaterialIcon = makeSvgIcon(
  svg,
  (theme) => theme.palette.data.dark
);

export default MaterialIcon;
